module.exports = __webpack_public_path__ + "static/media/synack.75a8cf25.png";